export const REVIEW_STEP_TITLE = 'Review';
export const TAG_SHEET_NO_SUBMITTABLE_ADS_TITLE =
  'Something went wrong. Please select the proper campaigns for ad assignment.';
